import { logger } from "cayo.ui";
import React, { FC } from "react";
import { CollectActionParametersDialogProps } from "../../components/Dialogs/types";
import { useDynamicTitle } from "../../components/Dialogs/useDynamicTitle";
import { useExternalSubmit } from "../../components/Dialogs/useExternalSubmit";
import Form from "../../components/Form";
import useTypeAnnotations from "../../components/GlobalHooks/type-annotations.hook";
import ObjectTitle from "../../components/ObjectTitle";
import Panel from "../../components/Panel/Panel";

const log = logger.getLogger("CollectActionParametersDialog");

const PropertiesDialog: FC<CollectActionParametersDialogProps> = (props) => {
  const { isWizard, icon } = props;
  const { getIconAnnotation } = useTypeAnnotations();

  const title = useDynamicTitle(props, log);
  const onSubmit = useExternalSubmit(props);

  return (
    <Panel
      type={"medium"}
      isOpen={true}
      onClose={props.onClose}
      isBlocking={true}
      helpLink={props.helpLink}
      hideToggleVerticalTabs={isWizard}
    >
      <ObjectTitle
        type={""}
        object={{ objectName: title }}
        titleProperty="objectName"
        isTitleReadonly={true}
        icon={icon}
      />
      <Form
        {...props}
        getIconAnnotation={getIconAnnotation}
        onSubmit={onSubmit}
        title=""
        isInsidePropPanel={true}
        sendAllFields={isWizard ?? false}
      />
    </Panel>
  );
};

export default PropertiesDialog;
